export const getReportingDetails = ({
  epdIRReportingPersonName,
  epdIRReportingPersonPhone,
  epdIRReportingPersonTitle,
}) => {
  return [
    {
      title: 'NAME AND TITLE OF REPORTING PERSON (PRINT)',
      detail: epdIRReportingPersonName,
      width: 5,
    },
    {
      title: 'TELEPHONE',
      detailKey: epdIRReportingPersonPhone,
      width: 3,
    },
    {
      title: 'SIGNATURE',
      detailKey: epdIRReportingPersonTitle,
      width: 2,
    },
    {
      title: 'DATE',
      detailKey: '',
      width: 2,
    },
  ];
};

export const getResponseAgencies = [
  { label: 'FIRE', checked: false },
  { label: 'PARAMEDICS', checked: false },
  { label: 'POLICE', checked: false },
];

export const getDivisions = ({
  epdIRNotifiedDAPO,
  epdIRNotifiedDHCS,
  epdIRNotifiedDRP,
  epdIRNotifiedOther,
}) => {
  return [
    { label: 'Dapo', checked: epdIRNotifiedDAPO },
    { label: 'DHCS', checked: epdIRNotifiedDHCS },
    { label: 'DRP', checked: epdIRNotifiedDRP },
    { label: 'Other: df', checked: epdIRNotifiedOther },
  ];
};
export const getGridFirstRow = ({ getIncidentDate, getIncidentTime }) => {
  return [
    { xs: 3, title: 'INCIDENT DATE', value: getIncidentDate },
    { xs: 4, title: 'INCIDENT TIME', value: getIncidentTime },
  ];
};

export const getGridSecondRow = ({ epdIcnCDC, prtKey }) => {
  return [
    { xs: 5, title: 'CDC NUMBER', value: epdIcnCDC },
    {
      xs: 3,
      title: 'PAROLEE NAME (LAST,FIRST,MI)',
      value: prtKey,
    },
    {
      xs: 4,
      title: 'PAROLEE AGENT OF RECORD (NAME AND TELEPHONE NUMBER)',
      value: '',
    },
  ];
};

export const getGridThirdRow = ({ epdIRLocation, epdIRLocationAddr }) => {
  return [
    {
      xs: 8,
      title: 'INCIDENT LOCATION/SITE NAME AND PHYSICAL ADDRESS',
      value: [`Name : ${epdIRLocation}`, `Address : ${epdIRLocationAddr}`],
    },
    {
      xs: 4,
      title: 'NAME AND ADDRESS OF REPORTING AGENCY OR PROGRAM',
      value: [`Name : `, `Address : `],
    },
  ];
};

export const getGridFourthRow = ({
  getAdmissionDate,
  epdIRCMName,
  epdIRCMPhone,
  epdIRCMEmail,
}) => {
  return [
    {
      xs: 8,
      title: 'PROGRAM ADMISSION DATE',
      value: getAdmissionDate,
    },
    {
      xs: 4,
      title: 'CASE MANAGER NAME TELEPHONE NUMBER AND E-MAIL ADDRESS',
      value: [
        `Name : ${epdIRCMName}`,
        `Telephone : ${epdIRCMPhone}`,
        `E-mail : ${epdIRCMEmail}`,
      ],
    },
  ];
};

export const getGridSixthRow = ({
  epdIRLawEnforcementAgency,
  epdIRArrestingAgency,
  getArrestDate,
}) => {
  return [
    {
      xs: 5,
      title: 'NAME OF THE LOCAL LAW ENFORCEMENT AGENCY CONTACTED',
      value: epdIRLawEnforcementAgency,
    },
    {
      xs: 3,
      title: 'IF ARRESTED, NAME OF ARRESTING AGENCY',
      value: epdIRArrestingAgency,
    },
    { xs: 4, title: 'DATE OF ARREST', value: getArrestDate },
  ];
};

export const getGridSeventhRow = ({ epdIRAgenciesContacted }) => {
  return [
    {
      xs: 4,
      title: 'NAME(S) OF AGENCY(IES) CONTACTED',
      value: epdIRAgenciesContacted,
    },
  ];
};

export const getGridEightthRow = ({
  epdIRNewMediaName,
  epdIRNewsMediaPhone,
}) => {
  return [
    {
      xs: 3,
      title: 'NAME OF NEWS MEDIA AGENCY',
      value: epdIRNewMediaName,
    },
    {
      xs: 4,
      title: `NEWS MEDIA REPRESENTATIVE'S NAME AND TELEPHONE NUMBER`,
      value: [
        `Name : `,
        `Telephone : ${
          epdIRNewsMediaPhone !== null ? epdIRNewsMediaPhone : ''
        }`,
      ],
    },
  ];
};

export const getFirstRowCheckbox = ({ divisions }) => {
  return [
    {
      xs: 5,
      title: 'CHECK ALL DIVISIONS THAT WERE NOTIFIED OF THIS INCIDENT',
      data: divisions,
    },
  ];
};

export const getFifthRowCheckbox = ({ yesNoOptions, getPerrolArrested }) => {
  return [
    {
      xs: 8,
      title: 'WAS LOCAL LAW ENFORCEMENT AGENCY CONTACTED?',
      data: yesNoOptions,
    },
    {
      xs: 4,
      title: 'WAS THE PPAROLEE ARRESTED?',
      data: getPerrolArrested,
    },
  ];
};

export const getSeventhRowCheckbox = ({ getMediaCoverage }) => {
  return [
    {
      xs: 5,
      title: 'NEWS MEDIA COVERAGE',
      data: getMediaCoverage,
    },
  ];
};

export const getEightthRowCheckbox = ({ getResponseAgencies }) => {
  return [
    {
      xs: 8,
      title: 'CHECK ALL THE EMERGENCY RESPONSE AGENCIES CONTACTED',
      data: getResponseAgencies,
    },
  ];
};

export const descriptionTitle1 = `DISCRIPTION OF INCIDENT`;
export const descriptionTitle2 = `PLEASE PROVIDE A DETAILED DESCRIPTIN OF KNOWN INFORMATION RELATED TO THIS INCIDENT (WHO, WHAT, WHEN, WHERE, HOW, AND IF KNOWN, WHY, AND INCLUDE THE NAMES OF WITNESSES OR OTHERS INVOLVED PARTIES AND ANY ACTIONS TAKEN OR FORCE USED.)`;
export const distributionTitle1 = `DISTRIBUTION :`;
export const distributionTitle2 = `ORIGINAL TO DIVISION OF REHABILITATIVE PROGRAMS, OFFICE OF OFFENDER SERVICES/COMMUNITY AND RE-ENTRYSERVICES COPYTO PAROLEAGENT OF RECORD`;
